import { FieldOption } from '@/forms/types/field-option';
import { FormSchema } from '@/forms/types/schema';
import { AssignDeviceFieldValues } from './field-values';

const assignDeviceFormSchema: FormSchema<AssignDeviceFieldValues> = {
  organisationId: {
    type: 'select',
    label: 'Organisation',
    value: undefined,
    validation: { required: true },
  },
};

export const buildAssignDeviceFormSchema = ({
  currentOrganisationId,
  organisationOptions,
}: {
  currentOrganisationId: number | undefined;
  organisationOptions: FieldOption<number>[];
}): FormSchema<AssignDeviceFieldValues> => {
  const schema = assignDeviceFormSchema;

  schema.organisationId = {
    ...schema.organisationId,
    value: currentOrganisationId,
    options: organisationOptions,
  };

  return schema;
};
